import { Controller } from "react-hook-form";
import { BaseField } from "./BaseField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { getFieldHelperText } from "../../services/fieldHelperText";
import { ColorPickerFieldInput } from "modules/record/shared/fields/ColorPickerFieldInput";

export const ColorPickerFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => (
    <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps} as="group">
        <Controller
            name={column.name}
            control={control}
            defaultValue={column.default_value || ""}
            rules={{
                required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)),
                pattern: {
                    value: /^#[0-9a-fA-F]{6}$/,
                    message: "Use a valid HEX color like #D71920.",
                },
            }}
            render={({ field, fieldState }) => (
                <ColorPickerFieldInput
                    value={field.value ?? ""}
                    onChange={field.onChange}
                    disabled={runtimeProps?.readonly}
                    error={!!fieldState.error}
                    helperText={getFieldHelperText(fieldState, runtimeProps)}
                />
            )}
        />
    </BaseField>
);
